module.exports = __webpack_public_path__ + "static/media/Picture1.d3290e97.png";